import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./RegisterB2BStyle.scss";
import { RegisterB2BModel } from "./RegisterB2BModel";
import FormPart1 from "./FormPart1";
import FormPart2 from "./FormPart2";
import { SubmitHandler, useForm } from "react-hook-form";
import { post } from "../../api";
import { useDispatch, useSelector } from "react-redux";
import { setErrors, setSuccessMessage } from "../../store/alerts/alertsActions";
import { B2B_REGISTER } from "../../api/apiRoutes";
import useFacility from "../../../utils/hooks/useFacility";
import EAAlert from "../shared/EAAlert";
import EAButton from "../shared/Buttons/EAButton";
import { FaArrowLeft } from "react-icons/fa";
import { MAIN_APP } from "../../routes";
import { State } from "../../store";

const RegisterB2BPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const { configuration } = useSelector((state: State) => state.config);
  const [part, setPart] = useState<1 | 2 | 3>(1);
  
  const offerId = searchParams.get("offerId");
  const id = searchParams.get("id");

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm<RegisterB2BModel>({
    defaultValues: {
      acceptRule: false,
    },
  });

  const handleRegistration: SubmitHandler<RegisterB2BModel> = async (data) => {
    if (part === 1) {
      setPart(2);
    } else if (part === 2) {
      const { isError, errorTable } = await post(B2B_REGISTER(facilityIds), data);
      if (!isError) {
        setPart(3);
        reset();
        dispatch(setSuccessMessage("Wysłaliśmy Twoją prośbę o dołączenie do partnerów"));
      } else {
        dispatch(setErrors(errorTable));
      }
    }
  };

  const handleBackToShop = () => {
    if (offerId) {
      navigate(`${MAIN_APP}?offerId=${offerId}${id ? `&id=${id}` : ""}`);
    } else {
      navigate(MAIN_APP);
    }
  };

  return (
    <div className="register-b2b-page">
      <div className="register-b2b-page-container">
        <div className="register-b2b-page-header">
          <div className="register-b2b-logo">
            {configuration?.logoUrl && (
              <img src={configuration.logoUrl} alt="Logo sklepu" />
            )}
          </div>
          <h2 className="text-centered no-margins">Zostań naszym partnerem</h2>
          <p className="text-centered">
            Jeśli otrzymałeś ten link od Park Wodny w Krakowie S.A. oznacza to, że zostałeś zaproszony do grona
            przedsiębiorców zamawiających wejściówki jako partner biznesowy.
          </p>
        </div>
        
        <div className="register-b2b-form">
          <form onSubmit={handleSubmit(handleRegistration)}>
            {part === 1 && (
              <>
                <FormPart1 errors={errors} register={register} />
                <div className="register-b2b-actions">
                  <EAButton
                    title="Powrót do sklepu"
                    variant="text"
                    startIcon={<FaArrowLeft />}
                    onClick={handleBackToShop}
                  />
                </div>
              </>
            )}
            {part === 2 && (
              <>
                <FormPart2 errors={errors} register={register} control={control} />
                
              </>
            )}
            {part === 3 && (
              <div className="register-b2b-form__success">
                <EAAlert type="success" message="Wysłaliśmy Twoją prośbę o dołączenie do partnerów" />
                <div className="register-b2b-actions" style={{ marginTop: '20px' }}>
                  <EAButton
                    title="Powrót do sklepu"
                    variant="filled"
                    startIcon={<FaArrowLeft />}
                    onClick={handleBackToShop}
                  />
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterB2BPage; 